import {
	Component,
	Input,
	booleanAttribute,
	ChangeDetectionStrategy,
} from "@angular/core"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "../common-imports"
import { byId, copy, getCheckedIds } from "@app/helpers"
import {
	BtnExtComponent,
	CancelBtnComponent,
	Check,
	SpinOrContent,
	TableWrapComponent,
} from "@app/utils/utils.component"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { PolicyFormsMenuComponent } from "@app/policy-forms-menu/policy-forms-menu.component"
import { PatientDetailsFieldsManageComponent } from "@app/patient-details-fields-manage/patient-details-fields-manage.component"
import { InviteTextsComponent } from "@app/invite-texts/invite-texts.component"

@Component({
	selector: "app-invite-prep",
	imports: [
		COMMON_IMPORTS,
		SpinOrContent,
		TableWrapComponent,
		GenSelectComponent,
		Check,
		LangValPipe,
		CancelBtnComponent,
		BtnExtComponent,
		ModalWrapComponent,
		PolicyFormsMenuComponent,
		PatientDetailsFieldsManageComponent,
		InviteTextsComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./invite-prep.component.html",
})
export class InvitePrepComponent extends Modalable {
	modalProps: any = null
	patient_id: number = 0
	patientDetails: boolean = false
	tests: any[] = []
	policyFormVersions: any[] = []
	inviteTexts: any[] = []
	isLoading: boolean = false
	enablePolicyForms: boolean = false
	templates: any[] = []
	@Input() state: any = null
	@Input({ transform: booleanAttribute }) hasTemplateChoice: boolean = false

	async ngOnInit() {
		this.isLoading = true
		this.enablePolicyForms = this.store.cc()?.enable_policy_forms == "yes"
		this.initTests()
		await this.initTexts()
		if (this.enablePolicyForms) {
			await this.initPFVs()
		}
		this.initState()
		if (this.hasTemplateChoice) {
			this.templates = (await this.store.get_gen_items("invite_templates"))
				?.invite_templates
		}
		this.isLoading = false
	}
	initState() {
		if (!this.state) {
			return
		}
		const obj = JSON.parse(this.state)
		this.patientDetails = obj?.patientDetails
		this.checkByIds(this.tests, obj?.testIds)
		this.checkByIds(this.policyFormVersions, obj?.policyFormVersionIds)
		this.checkByIds(this.inviteTexts, obj?.inviteTextsIds)
	}
	resetChecked(arr: any[]) {
		arr.forEach((it) => (it.checked = false))
	}
	checkByIds(arr: any[], ids: number[]) {
		ids
			?.map((id) => arr.find(byId(id)))
			.filter(Boolean)
			.forEach((obj) => (obj.checked = true))
	}
	initTests() {
		this.tests = this.store.getActiveTests().map(copy)
	}
	async initTexts() {
		this.inviteTexts = (
			await this.store.get_gen_items("invite_texts")
		)?.invite_texts
			?.filter((it) => it.current_text)
			.map(copy)
	}
	async initPFVs() {
		const versions = this.store
			.getSiteDataTable("policy_forms")
			.filter((pf) => pf.person_types?.includes("patient"))
			.map((pf) => this.store.getSortedVersions(pf.id).at(0))
			.filter(Boolean)
		const { ids } = await this.apiService.post("get_version_fills", {
			version_ids: versions.map((v) => v.id),
			patient_id: this.patient_id,
		})

		this.policyFormVersions = versions
			.filter((v) => !ids.includes(v.id))
			.map((v) => ({
				id: v.id,
				name: this.store.searchSiteDataItem(v.policy_form_id, ["policy_forms"])
					?.name,
			}))
	}
	closeChecked() {
		const sendObj = {
			patientDetails: this.patientDetails,
			testIds: getCheckedIds(this.tests),
			policyFormVersionIds: getCheckedIds(this.policyFormVersions),
			inviteTextsIds: getCheckedIds(this.inviteTexts),
		}
		this.onClose.emit(JSON.stringify(sendObj))
	}
	handleTemplateChange(id: any = null) {
		if (!id) {
			return
		}
		this.state = this.templates.find(byId(id)).state
		this.patientDetails = false
		this.resetChecked(this.tests)
		this.resetChecked(this.policyFormVersions)
		this.resetChecked(this.inviteTexts)
		this.initState()
	}
}
